import { cn } from '@/shadcn-ui/utils';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { colors } from '@/theme/colors';

export default function FilterShort({
  className,
  fillPrimary = colors.blue40,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[10px] w-[15px]', className)}
    >
      <path
        d="M4.22266 9.32324C4.02669 9.32324 3.86035 9.2526 3.72363 9.11133C3.58691 8.96549 3.51855 8.79688 3.51855 8.60547C3.51855 8.40495 3.58464 8.23405 3.7168 8.09277C3.85352 7.9515 4.02214 7.88086 4.22266 7.88086H11.4277C11.6283 7.88086 11.7969 7.9515 11.9336 8.09277C12.0749 8.23405 12.1455 8.40495 12.1455 8.60547C12.1455 8.80143 12.0749 8.97005 11.9336 9.11133C11.7969 9.2526 11.6283 9.32324 11.4277 9.32324H4.22266ZM2.84863 5.78223C2.65267 5.78223 2.48405 5.71159 2.34277 5.57031C2.20605 5.42904 2.1377 5.26042 2.1377 5.06445C2.1377 4.86849 2.20605 4.69987 2.34277 4.55859C2.48405 4.41276 2.65267 4.33984 2.84863 4.33984H12.8086C13.0046 4.33984 13.1709 4.41048 13.3076 4.55176C13.4443 4.69303 13.5127 4.86393 13.5127 5.06445C13.5127 5.26042 13.4443 5.42904 13.3076 5.57031C13.1709 5.71159 13.0046 5.78223 12.8086 5.78223H2.84863ZM1.44727 2.24805C1.25586 2.24805 1.08952 2.17741 0.948242 2.03613C0.811523 1.8903 0.743164 1.7194 0.743164 1.52344C0.743164 1.32747 0.811523 1.15885 0.948242 1.01758C1.08496 0.871745 1.2513 0.798828 1.44727 0.798828H14.1758C14.3809 0.798828 14.5495 0.869466 14.6816 1.01074C14.8184 1.15202 14.8867 1.32292 14.8867 1.52344C14.8867 1.72396 14.8184 1.89486 14.6816 2.03613C14.5449 2.17741 14.3763 2.24805 14.1758 2.24805H1.44727Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
